import { Injectable } from '@angular/core';
import { AuthProvider, UsuarioAutenticado } from '../models/auth.models';
import { AuthProviderService } from './auth/auth-provider.interface';
import { MicrosoftAuthProviderService } from './auth/microsoft-auth-provider.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly providers: AuthProviderService[];

  constructor(
    private microsoftProvider: MicrosoftAuthProviderService
  ) {
    this.providers = [
      this.microsoftProvider
    ];
  }

  async login(provider: AuthProvider): Promise<UsuarioAutenticado | null> {
    const authProvider = this.obterProvider(provider);
    return await authProvider.login();
  }

  async logout(provider: AuthProvider): Promise<void> {
    const authProvider = this.obterProvider(provider);

    await authProvider.logout();
  }

  async handleRedirect(): Promise<UsuarioAutenticado | null> {
    for (const provider of this.providers) {
        const usuario = await provider.handleRedirect();

        if (usuario) {
        return usuario;
        }
    }

    return null;
  }

  async getUsuario(
    provider: AuthProvider
  ): Promise<UsuarioAutenticado | null> {

    const authProvider = this.obterProvider(provider);

    return authProvider.getUsuario();
  }

  async getToken(
    provider: AuthProvider,
    scopes?: string[]
  ): Promise<string | null> {

    const authProvider = this.obterProvider(provider);

    return authProvider.getToken(scopes);
  }

  async estaAutenticado(
    provider: AuthProvider
  ): Promise<boolean> {

    const authProvider = this.obterProvider(provider);

    return authProvider.estaAutenticado();
  }

  private obterProvider(
    provider: AuthProvider
  ): AuthProviderService {

    const authProvider = this.providers.find(
      item => item.provider === provider
    );

    if (!authProvider) {
      throw new Error(
        `Provedor de autenticação não configurado: ${provider}`
      );
    }

    return authProvider;
  }
}